import { useState, useEffect } from 'react'
import { AllStatusWrapper } from '../../../../components/execution/terminal/AllStatusWrapper'
import { PaymentStatus, TerminalStatus, TerminalStatusContext } from '../../../../types/mf-execution.types'
import { useOrderPaymentStatusQuery } from '../../../../hooks/mf-execution/useOrderPaymentStatusQuery'
import { postCTA } from '../../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../../utils/mutualFundDetail'
import { convertMillisecondsToMinutesAndSeconds } from '../../../../utils/utils'

export const BuyNetBankPaymentStatusPage = () => {
  const [status, setStatus] = useState<TerminalStatus>(TerminalStatus.LOADING)

  const { paymentStatus, isError, isExpired, timeLeft } = useOrderPaymentStatusQuery({ maxTimer: 120000 })

  useEffect(() => {
    if (isError || paymentStatus?.status === PaymentStatus.FAILED) {
      setStatus(TerminalStatus.FAILURE)
    } else if (paymentStatus?.status === PaymentStatus.SUCCESS) {
      setStatus(TerminalStatus.FULL_SUCCESS)
    }
  }, [paymentStatus, isError])

  useEffect(() => {
    if (isExpired && status === TerminalStatus.LOADING) {
      setStatus(TerminalStatus.PENDING)
    }
  }, [isExpired, status])

  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={status}
        statusContext={TerminalStatusContext.BUY}
        loadingConfig={{
          title: 'Confirming your <br /> payment',
          caption: `This screen will timeout in ${convertMillisecondsToMinutesAndSeconds(timeLeft)} <br />  Do not press back or close this screen.`
        }}
        fullSuccessConfig={{
          title: 'Order placed',
          caption: 'Your investment will be processed <br /> within 3-4 working days.',
          ctas: [
            {
              ctaType: 'secondary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
        failureConfig={{
          title: 'Payment failed',
          caption: 'Any amount deducted will be credited to <br /> source within 2-4 working days.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
        pendingConfig={{
          title: 'Payment pending',
          caption: 'It’s taking longer than expected. We’ll <br /> notify you once your payment is confirmed.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Close',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}
